module.exports = __webpack_public_path__ + "img/Honig-aus-2021-500.f40a67c6.jpg";